import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonModify, ManageButton } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import ContainerIndex from '../../layouts/containers/container-index';
import IndexCard from '../../components/cards/index-card';
import InputsDropdown from '../../components/inputs/inputs-dropdown';
import { SmallPill } from '../../components/pills';
import SearchBar from '../../components/searchbar';
import Eye from '../../components/buttons/eye';
import Book from '../../components/buttons/book';
import meetingsApi from '../../lib/meetings/meetings-api';
import MediaHelper from '../../lib/helpers/media';
import Scrollable from '../../components/scrollable';
import auth from '../../lib/users/auth';
import { COMPANY_BOOK_MEETING_ROOMS } from '../../utils/permissions';
import LatestUpdates from '../dashboard/components/component-latest-updates';
import RenderThisIf from '../../components/renderIf';
import EmptyState from '../../components/states/empty';

class MeetingsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            meetings: null,
            order_by: {
                label: 'Order by Name',
                value: 'name'
            },
            order_direction: {
                label: 'Order by Descending',
                value: 'desc'
            },
            page: 1
        }
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        this.setState({ meetings: null });
        
        meetingsApi.getMeetingRooms({
            order_by: this.state.order_by?.value,
            order_direction: this.state.order_direction?.value,
            per_page: 10,
            page: this.state.page,
        }).then(({ data, meta }) => {
            this.setState({ meetings: data, meta });
        })
    }

    onOrderBy(e) {
        this.setState({ order_by: e }, () => {
            this.fetch();
        })
    }

    onOrderDirection(e) {
        this.setState({ order_direction: e }, () => {
            this.fetch();
        })
    }

    onNext() {
        this.setState({ page: this.state.page + 1 }, () => this.fetch())
    }

    onPrevious() {
        this.setState({ page: this.state.page - 1 }, () => this.fetch())
    }

    render() {
        return (
            <Layout 
                theme="dark"
                topLeft={<Welcome seam title="Welcome to" subtitle="Meeting Rooms"/>}
                topRight={
                    <Row gap="20px">
                
                    </Row>
                }
            >
                <SeventyThirtyLayout
                    main={
                        <Container>
                            <Container.Header>
                                <Row gap="20px">
                                    <Container.Icon src="/assets/icons/trophy.svg"/>
                                    <Container.Text fontSize="18px" fontWeight="500" color="#FCFCFC">Meeting Rooms</Container.Text>
                                </Row>
                            </Container.Header>

                            <Container.Content>
                                <ContainerIndex>
                                    <ContainerIndex.Filters>
                                        <List gap="20px" style={{ width: '100%' }}>
                                            <Row gap="20px" wrap>
                                                <InputsDropdown
                                                    items={[
                                                        {
                                                            label: 'Order by Created at',
                                                            value: 'created_at'
                                                        },
                                                        {
                                                            label: 'Order by Name',
                                                            value: 'name'
                                                        }
                                                    ]} 
                                                    value={this.state.order_by} 
                                                    icon="sort" 
                                                    onChange={this.onOrderBy.bind(this)}
                                                />
                                                <InputsDropdown
                                                    items={[
                                                        {
                                                            label: 'Order by Ascending',
                                                            value: 'asc'
                                                        },
                                                        {
                                                            label: 'Order by Descending',
                                                            value: 'desc'
                                                        }
                                                    ]} 
                                                    value={this.state.order_direction} 
                                                    icon="sort" 
                                                    onChange={this.onOrderDirection.bind(this)}
                                                />
                                            </Row>
                                        </List>
                                    </ContainerIndex.Filters>

                                    <RenderThisIf
                                        renderIf={this.state?.meetings === null || this.state.meetings?.length === 0}
                                        render={
                                            <EmptyState 
                                                loading={this.state.meetings === null} 
                                                title="Meeting Rooms"
                                                description="There seems to be nothing here" 
                                                style={{ width: '100%', minHeight: '300px' }}
                                            />
                                        }
                                    >
                                        <ContainerIndex.Content>
                                            { this.state?.meetings?.map((meeting, index) => {
                                                const getLocation = () => {
                                                    const { name, address_one, address_two, address_post_code, address_city } = meeting?.office_building || {
                                                        name: '',
                                                        address_one: '',
                                                        address_two: '',
                                                        address_post_code: '',
                                                        address_city: ''
                                                    };
                                            
                                                    let string = [
                                                        name,
                                                        address_one,
                                                        address_two,
                                                        address_post_code,
                                                        address_city
                                                    ].filter(e => e !== undefined && e !== null);
                                            
                                                    return string.join(', ');
                                                }

                                                const getFeaturedImage = () => {
                                                    const image = meeting?.content?.room_feature_image?.[0];

                                                    if (image?.file_name === undefined) return '/images/office.png';
                                            
                                                    return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
                                                }

                                                return (
                                                    <IndexCard
                                                        key={index}
                                                        image={getFeaturedImage()}
                                                        title={meeting?.name}
                                                        subtitle={getLocation()}
                                                        infos={[
                                                            {
                                                                label : 'Max Capacity',
                                                                value : meeting?.max_attendees
                                                            }
                                                        ]}
                                                        buttons={
                                                            <>
                                                                <Button color="black" transparent leftIcon={<Eye/>} onClick={() => window.location.href = `/mydmc/meeting-rooms/${meeting.id}`}>Overview</Button>
                                                                { (auth.hasPermission(COMPANY_BOOK_MEETING_ROOMS) || auth.isOwnerOrManager()) && <Button color="black" transparent leftIcon={<Book/>} onClick={() => window.location.href = `/mydmc/meeting-rooms/${meeting.id}/book`}>Book</Button> }
                                                            </>
                                                        }
                                                    />
                                                )
                                            })}
                                        </ContainerIndex.Content>
                                    </RenderThisIf>

                                    <ContainerIndex.Pagination
                                        currentPage={this.state.page}
                                        maxPages={this.state.meta?.last_page}
                                        onNext={this.onNext.bind(this)}
                                        onPrevious={this.onPrevious.bind(this)}
                                    />
                                </ContainerIndex>
                            </Container.Content>
                        </Container>
                    }
                    sectionOne={
                        {
                            name: 'Side',
                            component: (
                                <Container>
                                    <Container.Header>
                                        <Row gap="20px">
                                            <Container.Icon src="/assets/icons/trophy.svg"/>
                                            <Container.Text fontSize="18px" fontWeight="500" color="#FCFCFC">Latest DMC Updates</Container.Text>
                                        </Row>
                                    </Container.Header>

                                    <Container.Content>
                                        <LatestUpdates/>
                                    </Container.Content>
                                </Container>
                            )
                        }
                    }
                />
            </Layout> 
        )
    }
}

const el = document.getElementById('meetings-index');

if (el) {
    ReactDOM.render(
        <MeetingsIndex/>   
    , el);
}
